module.exports = __webpack_public_path__ + "static/media/like.cba4f228.svg";